import { useSelector } from "react-redux";
import { useMemo } from "react";
import Delete from "@assets/images/icons/delete.svg";
import More from "@assets/images/icons/more.svg";
import { SelectionBarTemplete } from "@components/templates/SelectionBar/SelectionBar";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import getTrackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { pendoEventType } from "@containers/ShipmentsBookmark/utils/constant";

export const SelectionBar = ({ setShowFavModal, clearSelection, setShowDeleteModal, selectedCompanyArray, type }) => {
  const userDetails = useSelector((state) => state.userDetails);

  const selectionOptions = useMemo(() => {
    if (userDetails?.userData) {
      let selectionOptionsClone = [
        {
          icon: More,
          name: "Add Tags",
          cb: () => {
            setShowFavModal(true);
            trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "bulk_add_tags", { ...generateTrackingObject(`intel-${type}-favourite`) });
          },
        },
        {
          icon: Delete,
          name: "Remove",
          cb: () => {
            setShowDeleteModal(true);
            trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "bulk_delete", { ...generateTrackingObject(`intel-${type}-favourite`) });
          },
        },
      ];
      return selectionOptionsClone;
    }
  }, [userDetails, selectedCompanyArray]);

  return (
    <div className="d-inline-block mt-3">
      <SelectionBarTemplete type={type} options={selectionOptions} clearSelection={clearSelection} selectedCompanyArray={selectedCompanyArray} />
    </div>
  );
};
